<template>
  <div>
    <b-row>
      <b-col cols="7">
        <small>
          <b>{{ item.firstName }} {{ item.lastName }}</b
          ><br />
          <span class="text-muted">{{ item.email }}</span>
        </small>
      </b-col>
      <b-col cols="5" class="text-right">
        <small class="text-muted">ID {{ item.key }}</small>
      </b-col>
      <b-col cols="5" class="text-right" v-if="hasRole('BETA')">
        <small
          ><b>{{ (item.balance / 100) | currency }}</b
          ><br />
          Balance</small
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "customer-search-item",
  props: { item: null },
  inject: ["hasRole"],
  data() {
    return {
      hasLedger: false,
    };
  },
  created() {},
};
</script>

<style></style>
